import { render, staticRenderFns } from "./field_customer.vue?vue&type=template&id=2fc56fce"
import script from "./field_customer.vue?vue&type=script&lang=js"
export * from "./field_customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports